import { post } from './http'

const baseUrl = '/api/meas/admin/resource/quesbank'

// 获取题库列表
export const getQuestionbankList = data => post(`${baseUrl}/getQuestionbankList`, data)

// 获取题库详情
export const getQuestionbankDetails = data => post(`${baseUrl}/getQuestionbankDetails`, data)

// 新增修改题库
export const saveQuestionbank = data => post(`${baseUrl}/saveQuestionbank`, data)

// 删除题库 
export const updateQuestionbankStatus = data => post(`${baseUrl}/updateQuestionbankStatus`, data)
